import { Link } from "react-router-dom";
import "./404.css";
import { authActions } from "../store/auth";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const NotFound = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });
  return (
    <div className="emptyDiv pt-5">
      {/* <img src={`${process.env.PUBLIC_URL}/assets/images/logo.png`} alt="img" /> */}
      <h1 className="message__title">404</h1>

      <h2 className="">Uh Oh! Page Not Found</h2>
      <p className="message__text">
        We're sorry, the page you were looking for isn't found here. The link
        you followed may either be broken or no longer exists. Please try again,
        or take a look at our.
      </p>
      <p className="message__text">
        Let's go <Link to="/">home</Link> and try from home
      </p>
    </div>
  );
};

export default NotFound;
